const headCells = [
  { id: 'id', numeric: false, disablePadding: true, label: 'Номер/Название', width: '116px' },
  {
    id: 'color',
    numeric: false,
    disablePadding: true,
    label: '',
    width: '30px',
  },
  {
    id: 'startWork',
    numeric: true,
    disablePadding: false,
    label: 'Начало',
    width: '112px',
  },
  {
    id: 'finishWork',
    numeric: true,
    disablePadding: false,
    label: 'Завершение',
    width: '112px',
  },
  {
    id: 'garageName',
    numeric: true,
    disablePadding: false,
    label: 'Гараж',
    width: '186px',
  },
  {
    id: 'averageSpeed',
    numeric: true,
    disablePadding: false,
    label: 'Скорость (город/трасса), км/ч',
    width: '164px',
  },
  {
    id: 'trailer',
    numeric: true,
    disablePadding: false,
    label: 'Прицеп',
    width: '142px',
  },
  {
    id: 'sectionCount',
    numeric: true,
    disablePadding: false,
    label: 'Кол-во секций',
    width: '142px',
  },
  {
    id: 'loadFactor',
    numeric: true,
    disablePadding: false,
    label: 'Коэффициент загрузки, %',
    width: '112px',
  },
  {
    id: 'timePeriod',
    numeric: true,
    disablePadding: false,
    label: 'Рабочее время',
    width: '142px',
  },
  {
    id: 'mileage',
    numeric: true,
    disablePadding: false,
    label: 'Пробег, км',
    width: '112px',
  },
  {
    id: 'func',
    numeric: false,
    disablePadding: false,
    label: '',
    width: '30px',
  },
];

export default headCells;
